// extracted by mini-css-extract-plugin
export default {"link":"GN-z","disabled":"HN-z"};